<!-- <div class="rounded-2.5xl w-176 text-center"> -->
<div class="rounded-2.5xl w-full text-center">
  <!-- Header -->
  <div class="px-12 md:px-24 py-6 md:py-12 border-gray-300 border-b">
    <h1 class="text-xl md:text-3xl">
      <span class="flex flex-col items-center">
        <img
          [src]="configurationService.configuration.logo"
          alt="Club logo"
          class="mb-2 h-20" />
        <span class="text-red">WELCOME!</span>
      </span>
    </h1>
  </div>
  <div class="px-12 md:px-24 py-6 md:py-12">
    <!-- <h4 class="font-normal">{{ content }}</h4> -->
    <h4 class="font-normal">
      Would you like to view a quick tutorial before purchasing tickets?
    </h4>
    <div class="flex justify-center mt-5 md:mt-12">
      <sdc-button
        class="gs-modal-btn--outline"
        className="disabled:!opacity-30 mr-3 md:mr-6 !w-28 min-w-max h-10 !font-normal"
        data-cy="dismiss-tutorial-modal-button"
        theme="theme-sdc"
        variant="outline"
        (onClick)="close()">
        No
      </sdc-button>
      <sdc-button
        class="gs-modal-btn--primary"
        className="disabled:!opacity-30 !w-28 min-w-max h-10 !font-normal"
        data-cy="accept-tutorial-modal-button"
        theme="theme-sdc"
        variant="primary"
        (onClick)="accept()">
        Yes
      </sdc-button>
    </div>
    <div class="hidden md:block mt-3 small info-help">
      <span
        >For questions or assistance,<br />please call
        <b>{{ configurationService.configuration.phone }}</b
        ><br />or email
        <b>{{ configurationService.configuration.email }}</b></span
      >
    </div>
  </div>
</div>
